<!-- 地图展示 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_contact.png"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="地图展示" en="MAP DISPLAY"></sub-title>
        <div class="box">
          <div class="info">
            <div class="item">
              <img src="../../assets/icon_phone.png" alt="" class="icon" />
              <div>{{ globalConfig.linkPhone }}</div>
            </div>
            <div class="item">
              <img src="../../assets/icon_addr.png" alt="" class="icon" />
              <div>{{ globalConfig.linkAddress }}</div>
            </div>
            <div class="item">
              <img src="../../assets/icon_location.png" alt="" class="icon" />
              <div>{{ globalConfig.trafficRoutes }}</div>
            </div>
          </div>
          <div class="out">
            <div id="map"></div>
            <img
              src="http://api.zyzxgc.cn/file/static/map_scale.png"
              alt=""
              class="map"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
import { URL } from "@/util/config";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      URL,
      routerHistory: [], // 当前所在位置
      subNavs: [],
      bannerList: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList", "globalConfig"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {
    this.getBanner();
    setTimeout(() => {
      this.initMap();
    }, 1000);
  },
  methods: {
    async getBanner() {
      let res = await this.$api.getBannerList({ type: 2 });
      this.bannerList = res.data;
      setTimeout(() => {
        this.initBannerSwiper();
      }, 10);
    },
    // 初始化banner swiper
    initBannerSwiper() {
      new window.Swiper("#banner", {
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    },
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find((ele) => {
        const firstPath = this.$route.path.split("/")[1];
        return ele.path != "/" && "/" + firstPath == ele.path;
      });
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    initMap() {
      if (!window.T) {
        return;
      }
      const map = new window.T.Map("map");
      const point = this.globalConfig.latitudeLongitude
        .split(",")
        .map((ele) => Number(ele));
      const centerPoint = new window.T.LngLat(point[0], point[1]);
      map.centerAndZoom(centerPoint, 16);
      map.enableScrollWheelZoom(true);
      const zoomCtrl = new window.T.Control.Zoom();
      map.addControl(zoomCtrl);
      const scaleCtrl = new window.T.Control.Scale();
      map.addControl(scaleCtrl);
      const marker = new window.T.Marker(centerPoint);
      map.addOverLay(marker);
      const infoContent = `<div>
      <div style="font-weight:bold;font-size:16px;">${this.globalConfig.name}</div>
      <div style="width:250px;font-size:14px;margin-top:5px;">${this.globalConfig.linkAddress}</div>
      </div>`;
      const infoWindow = new window.T.InfoWindow(infoContent, {
        width: 250,
        height: 70,
        offset: new window.T.Point(0, -30), // 偏移量（避免遮挡标注）
      });
      marker.addEventListener("click", () => {
        map.openInfoWindow(infoWindow, centerPoint);
      });
      map.openInfoWindow(infoWindow, centerPoint);
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    height: 600px;
    object-fit: cover;
    display: block;
  }
  .wrap {
    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 300px;

    .box {
      margin-top: 60px;
    }
    .info {
      padding: 0 50px;
      margin-bottom: 50px;

      .item {
        display: flex;
        align-items: center;
        font-size: 26px;
        color: #5e5d5d;
        margin-bottom: 20px;

        .icon {
          width: 31px;
          margin-right: 12px;
        }
      }
    }

    .out {
      position: relative;
    }
    #map {
      width: 100%;
      height: 600px;
      z-index: 0;
    }
    .map {
      width: 500px;
      position: absolute;
      right: 10px;
      bottom: -250px;
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .box {
        margin-top: 20px;
      }
      .info {
        padding: 0;
        margin-bottom: 10px;

        .item {
          margin-bottom: 10px;
          font-size: 15px;

          .icon {
            width: 25px;
          }
        }
      }
      #map {
        height: 500px;
      }
      .map {
        display: none;
      }
    }
  }
}
</style>
